import { css } from '@bts-web/utils-style-engine';
import { TradeInputErrorType } from '../MainTradeForm/hooks/useTradeInput';
import { FilledExclamationMark } from '../../../common/svgIcons';

export const errorElementStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 'extra_small_3',
  color: 'warning.text_primary',
  fontSize: 'caption.small_light',
  fontWeight: 'caption.small_light',
  letterSpacing: 'caption.small_light',
  lineHeight: 'caption.small_light',
};

const MainTradeFormErrorBox = ({
  errors,
  errorTooHigh,
  errorTooLow,
}: {
  errors: TradeInputErrorType;
  errorTooHigh: string;
  errorTooLow: string;
}) => {
  return (
    <>
      {errors.tooHigh && (
        <span
          className={css(errorElementStyles)}
          data-testid="special-input-field__error"
          data-element="error"
          aria-label="error too high"
        >
          <FilledExclamationMark size={16} />

          {errorTooHigh}
        </span>
      )}

      {errors.tooLow && (
        <span
          className={css(errorElementStyles)}
          data-testid="special-input-field__error"
          data-element="error"
          aria-label="error too low"
        >
          <FilledExclamationMark size={16} />

          {errorTooLow}
        </span>
      )}

      {errors.customError && (
        <span
          className={css(errorElementStyles)}
          data-testid="special-input-field__error"
          data-element="error"
          aria-label="error generic"
        >
          <FilledExclamationMark size={16} />

          {errors.customError}
        </span>
      )}
    </>
  );
};

export { MainTradeFormErrorBox };
